import '../../../../dmView/style/App.css';
import Icon from '../../../components/Icon';

const defaultPlayerOptions = {
    showBlood: false,
    showDead: false,
    showHp: false,
    showHpBar: false,
    showAc: false
}

const WhoAreYouIcon = ({creature, handleSetSelectedCharacter}) => {
    return (
        <div style={{cursor: 'pointer'}} onClick={() => handleSetSelectedCharacter(creature)} >
            <Icon key={creature.creatureGuid} isTurn={false} creature={creature} iconOptions={defaultPlayerOptions} iconSize={{width: 200, height: 240}}/>
        </div>
    );
};

export default WhoAreYouIcon;